/** Um indicador do comparativo do PDV (ticket 07): valor atual, baseline e variação percentual. */
export interface ComparativoPdvIndicadorModel {
  atual: number;
  anterior: number;
  variacaoPercentual?: number;
}

/** Comparativo dos indicadores de operação do PDV contra o período anterior. */
export interface ComparativoPdvModel {
  faturado: ComparativoPdvIndicadorModel;
  cupons: ComparativoPdvIndicadorModel;
  ticketMedio: ComparativoPdvIndicadorModel;
  operadoresAtivos: ComparativoPdvIndicadorModel;
  caixasEmOperacao: ComparativoPdvIndicadorModel;
}

function emptyIndicador(): ComparativoPdvIndicadorModel {
  return { atual: 0, anterior: 0 };
}

export function emptyComparativoPdv(): ComparativoPdvModel {
  return {
    faturado: emptyIndicador(),
    cupons: emptyIndicador(),
    ticketMedio: emptyIndicador(),
    operadoresAtivos: emptyIndicador(),
    caixasEmOperacao: emptyIndicador(),
  };
}
